export const OauthFlowType = {
	PasswordGrant: "PasswordGrant",
	ClientCredentialsGrant: "ClientCredentialsGrant",
} as const;
